import { Link } from "react-router-dom";
import { ScrollText } from "lucide-react";
import Navbar from "@/components/Navbar";
import { Card } from "@/components/ui/card";
import Seo from "@/components/Seo";

const LegalNotice = () => {
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Mentions légales"
        description="Mentions légales de Click&Gard : éditeur, hébergeur, propriété intellectuelle et coordonnées de la société."
      />
      <Navbar />
      <main className="w-full px-4 md:px-6 lg:px-8 py-16">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 animate-fade-in">
            <div className="inline-flex w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-secondary items-center justify-center shadow-neon mb-5">
              <ScrollText className="w-8 h-8 text-primary-foreground" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold font-display tracking-tight mb-4">
              Mentions <span className="text-gradient-static">légales</span>
            </h1>
            <p className="text-sm text-muted-foreground">Dernière mise à jour : 20 avril 2026</p>
          </div>

          <Card className="card-glass-premium p-8 md:p-10 rounded-3xl space-y-8 text-foreground">
            <section>
              <h2 className="text-xl font-bold mb-3 text-primary">1. Éditeur du site</h2>
              <p className="text-muted-foreground leading-relaxed">
                Le site <strong className="text-foreground">Click&Gard</strong> (clickandgard.fr) est édité par Click&Gard.
                Pour toute question, vous pouvez nous contacter à l'adresse :{" "}
                <a href="mailto:contact@clickandgard.fr" className="text-primary hover:underline">
                  contact@clickandgard.fr
                </a>.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3 text-primary">2. Hébergement</h2>
              <p className="text-muted-foreground leading-relaxed">
                Le site est hébergé par des prestataires d'infrastructure cloud assurant la disponibilité,
                la sécurité et la performance du service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3 text-primary">3. Propriété intellectuelle</h2>
              <p className="text-muted-foreground leading-relaxed">
                L'ensemble du contenu présent sur Click&Gard (textes, images, logos, design, code) est protégé
                par le droit d'auteur. Toute reproduction ou utilisation sans autorisation préalable est interdite.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3 text-primary">4. Responsabilité</h2>
              <p className="text-muted-foreground leading-relaxed">
                Click&Gard met en relation des parents et des professionnels de la garde d'enfants.
                Bien que nous vérifions manuellement les profils professionnels, la responsabilité de la prestation
                relève des parties qui contractent entre elles.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3 text-primary">5. Données personnelles & RGPD</h2>
              <p className="text-muted-foreground leading-relaxed">
                Le traitement de vos données personnelles est détaillé dans notre{" "}
                <Link to="/privacy" className="text-primary hover:underline">Politique de confidentialité</Link>.
                Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement
                et d'opposition. Pour toute demande, contactez{" "}
                <a href="mailto:contact@clickandgard.fr" className="text-primary hover:underline">
                  contact@clickandgard.fr
                </a>.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3 text-primary">6. Droit applicable</h2>
              <p className="text-muted-foreground leading-relaxed">
                Les présentes mentions légales sont régies par le droit français.
                Tout litige relèvera des juridictions françaises compétentes.
              </p>
            </section>
          </Card>

          <div className="mt-8 text-center">
            <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              ← Retour à l'accueil
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LegalNotice;
